import type { LeadStatus } from '@/types';

export const LEAD_STATUS_LABEL: Record<LeadStatus, string> = {
  New: 'New',
  FollowUp: 'Follow Up',
  NoAnswer: 'No Answer',
  Accepted: 'Accepted',
  Declined: 'Declined',
};

export const LEAD_STATUS_CHIP: Record<LeadStatus, string> = {
  New: 'bg-amber-100 text-amber-800',
  FollowUp: 'bg-blue-100 text-blue-800',
  NoAnswer: 'bg-slate-100 text-slate-700',
  Accepted: 'bg-green-100 text-green-800',
  Declined: 'bg-red-100 text-red-700',
};

export const LEAD_STATUS_PILL: Record<LeadStatus, { bg: string; text: string }> = {
  New: { bg: '#fef3c7', text: '#92400e' },
  FollowUp: { bg: '#dbeafe', text: '#1e40af' },
  NoAnswer: { bg: '#f1f5f9', text: '#334155' },
  Accepted: { bg: '#dcfce7', text: '#166534' },
  Declined: { bg: '#fee2e2', text: '#b91c1c' },
};

/** Main color per lead status, for the tinted status chips (see lib/statusChip). */
export const LEAD_STATUS_COLOR: Record<LeadStatus, string> = {
  New: '#d97706',
  FollowUp: '#2563eb',
  NoAnswer: '#64748b',
  Accepted: '#16a34a',
  Declined: '#dc2626',
};

export const EDITABLE_LEAD_STATUSES: Exclude<LeadStatus, 'Accepted'>[] = ['New', 'FollowUp', 'NoAnswer', 'Declined'];

export function tagPillText(bgColor: string): string {
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  return ((r * 299 + g * 587 + b * 114) / 1000) > 128 ? '#0f172a' : '#ffffff';
}
